function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E2E0"
    },
    points: "124.848,269.271 77.266,342.203 169.797,434.734 242.729,387.152 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EE3840"
    },
    points: "399.814,264.006 247.994,112.186 113.752,133.156 30.279,216.628 138.981,221.199 290.801,373.019 295.372,481.721 378.844,398.248 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCC4C1"
    },
    d: "M499.255,12.745c-89.728-24.901-173.329,21.509-212.564,60.744 C274.968,85.212,99.687,260.493,99.687,260.493l151.82,151.82c0,0,158.682-158.682,187.003-187.003 C477.745,186.075,524.156,102.473,499.255,12.745z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 394.032,
    cy: 119.129,
    r: 42.81
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EED202"
    },
    d: "M100.53,409.819c-4.524-4.523-11.86-4.523-16.384,0l-62.022,62.023 c-4.524,4.524-4.524,11.86,0,16.385c2.263,2.261,5.227,3.393,8.192,3.393c2.965,0,5.93-1.132,8.192-3.393l62.022-62.023 C105.054,421.679,105.054,414.343,100.53,409.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EED202"
    },
    d: "M63.993,389.667c4.524-4.524,4.524-11.86,0-16.385c-4.524-4.523-11.86-4.523-16.385,0L3.394,417.499 c-4.524,4.524-4.524,11.86,0,16.385c2.261,2.261,5.227,3.393,8.192,3.393s5.93-1.132,8.192-3.393L63.993,389.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EED202"
    },
    d: "M122.333,448.007l-44.216,44.216c-4.524,4.524-4.524,11.86,0,16.385 c2.263,2.261,5.227,3.393,8.192,3.393c2.965,0,5.93-1.132,8.192-3.393l44.216-44.216c4.524-4.524,4.524-11.86,0-16.385 C134.194,443.483,126.858,443.483,122.333,448.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11113F"
    },
    d: "M504.624,15.441c-1.087-3.918-4.149-6.978-8.064-8.066c-42.222-11.718-87.955-9.438-132.256,6.59 c-34.328,12.42-67.714,33.241-91.597,57.126l-36.025,36.025l-130.51,20.386c-2.426,0.379-4.668,1.519-6.404,3.254l-83.472,83.472 c-3.251,3.252-4.273,8.117-2.603,12.4s5.715,7.173,10.307,7.367l82.339,3.463l-20.636,20.636c-4.524,4.524-4.524,11.86,0,16.385 l12.045,12.044l-35.975,55.144c-2.994,4.589-2.365,10.647,1.511,14.522l92.531,92.53c3.875,3.874,9.933,4.507,14.523,1.511 l55.141-35.976l12.045,12.045c4.524,4.523,11.86,4.523,16.385,0l20.636-20.636l3.463,82.336c0.193,4.593,3.084,8.638,7.367,10.307 c1.367,0.533,2.792,0.791,4.205,0.791c3.017,0,5.98-1.181,8.194-3.393l83.472-83.472c1.737-1.737,2.875-3.979,3.255-6.404 l20.387-130.509l36.024-36.025c23.884-23.884,44.706-57.27,57.126-91.596C514.063,103.396,516.342,57.662,504.624,15.441z  M165.549,425.686l-79.235-79.235l28.176-43.187l38.93,38.931l-4.578,4.578c-4.525,4.524-4.525,11.86,0,16.385 c4.524,4.523,11.86,4.523,16.385,0l4.578-4.578l38.93,38.93L165.549,425.686z M424.525,222.91l-38.695,38.696 c-0.005,0.005-0.009,0.009-0.014,0.014l-40.263,40.263c-4.524,4.524-4.524,11.86,0,16.385c4.524,4.523,11.86,4.523,16.385,0 l15.156-15.156l-14.904,95.408l-62.142,62.143l-3.248-77.256l32.372-32.372c4.524-4.524,4.524-11.86,0-16.385 c-4.524-4.523-11.86-4.523-16.385,0l-35.938,35.938c-0.02,0.02-0.038,0.038-0.058,0.058l-31.076,31.075l-10.33-10.33 c-0.118-0.122-0.236-0.241-0.359-0.358l-48.837-48.838L326.303,202.08c4.524-4.524,4.525-11.86,0-16.385 c-4.523-4.522-11.858-4.523-16.384,0L169.804,325.812l-48.839-48.839c-0.116-0.12-0.234-0.239-0.356-0.356l-10.33-10.332 l31.076-31.076c0.02-0.019,0.038-0.037,0.057-0.057l35.938-35.938c4.525-4.524,4.525-11.86,0-16.385 c-4.523-4.523-11.86-4.523-16.384,0l-32.372,32.372l-77.256-3.25l62.142-62.142l95.408-14.903l-15.156,15.154l16.384,16.385 l40.141-40.141c0.087-0.085,0.174-0.17,0.258-0.258l38.574-38.574C321.328,55.236,397.877,7.47,483.953,28.046 C504.529,114.123,456.763,190.674,424.525,222.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11113F"
    },
    d: "M355.565,79.507c-10.274,10.275-15.932,23.935-15.932,38.464c0,14.53,5.658,28.19,15.932,38.464 c10.604,10.604,24.534,15.905,38.464,15.905c13.93,0,27.859-5.301,38.462-15.905c10.275-10.274,15.932-23.934,15.932-38.464 c0-14.529-5.658-28.189-15.932-38.464C411.283,58.299,376.775,58.299,355.565,79.507z M416.107,140.05 c-12.175,12.177-31.983,12.176-44.159,0c-5.898-5.898-9.145-13.738-9.145-22.08c0-8.34,3.248-16.182,9.145-22.08 c6.088-6.088,14.083-9.131,22.08-9.131c7.995,0,15.993,3.045,22.079,9.131c5.898,5.898,9.146,13.739,9.146,22.08 C425.254,126.313,422.005,134.152,416.107,140.05z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.127043bd3df94957a8ef93efe7ba5390.svg";
export { ForwardRef as ReactComponent };